import request from "@/router/axios"
export const getResourcesConfig = () => {
    return request({
        url: `/api/zl/resource/config/getResourceConfigs`,
        method: 'get',
    })
}
export const delConfig = (ids) => {
    return request({
        url: `/api/zl/resource/config/del`,
        method: "post",
        params: {
            ids,
        },
    });
};
export const list = () => {
    return request({
        url: `/api/basis/print/template/list`,
        method: 'post',
        data: {
            orderBy: "createTime",
            isDesc: false
        }
    })
}
export const saveOrUpdate = (data) => {
    return request({
        url: `/api/zl/resource/config/saveOrUpdate`,
        method: 'post',
        data
    })
}
export const getConfig = (belongId) => {
    return request({
        url: `/api/zl/resource/config/getConfig`,
        method: 'get',
        params: {
            belongId: belongId
        }
    })
}
export const getSignPrintTemp = (resourceId) => {
    return request({
      url: `/api/zl/resource/config/getSignPrintTemp`,
      method: "get",
      params: {
        resourceId
      },
    });
  };